export const calculateCurrencyAmount = ({
  amount,
  scalePM
}: {
  amount?: number;
  scalePM?: number;
} = {}) => (amount && scalePM ? (amount / 100) * scalePM : 0);
